import { render, staticRenderFns } from "./PriceAdminComponent.vue?vue&type=template&id=70e7ac7c&scoped=true"
import script from "./PriceAdminComponent.vue?vue&type=script&lang=js"
export * from "./PriceAdminComponent.vue?vue&type=script&lang=js"
import style0 from "./PriceAdminComponent.vue?vue&type=style&index=0&id=70e7ac7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7ac7c",
  null
  
)

export default component.exports